import React, { useState} from "react";
import imageCompression from "browser-image-compression";
import img from "../assets/Spinner-3.gif";

function BgcForm() {
    const [isSameAddressChecked, setIsSameAddressChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [step, setStep] = useState(1);

    /* first form field */
    const [name, setName] = useState("");
    const [fname, setFname] = useState("");
    const [mname, setMname] = useState("");
    const [gender, setGender] = useState("");
    const [date, setDate] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [enumber, setEnumber] = useState("");
    const [companyname, setCompanyName] = useState("Intenim Technologies");
    const [location, setLocation] = useState("");
    const [language, setLanguage] = useState("");
    const [blood, setBlood] = useState("");

    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [post, setPost] = useState("");
    const [police, setPolice] = useState("");
    const [district, setDistrict] = useState("");
    const [tehsil, setTehsil] = useState("");
    const [landmark, setLandmark] = useState("");
    const [pincode, setPincode] = useState("");
    const [state, setState] = useState("");

    const [address11, setAddress11] = useState("");
    const [address22, setAddress22] = useState("");
    const [address33, setAddress33] = useState("");
    const [post1, setPost1] = useState("");
    const [police1, setPolice1] = useState("");
    const [district1, setDistrict1] = useState("");
    const [tehsil1, setTehsil1] = useState("");
    const [landmark1, setLandmark1] = useState("");
    const [pincode1, setPincode1] = useState("");
    const [state1, setState1] = useState("");

    /* forth form field */
    const [aadhar, setAadhar] = useState("");
    const [aadhar_front_side, setAadhar_Front_Side] = useState("");
    const [aadhar_back_side, setAadhar_Back_Side] = useState("");
    const [passport_size_photo, setPassport_Size_Photo] = useState("");

    const [candidate, setCandidateId] = useState("");


    const handleFileChange = async (event, setStateFunction) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const fileType = file.type;

                if (
                    fileType === "application/pdf" ||
                    fileType === "image/jpeg" ||
                    fileType === "image/png" ||
                    fileType === "image/jpg"
                ) {
                    if (fileType === "application/pdf") {
                        setStateFunction(file);
                    } else {
                        const options = {
                            maxSizeMB: 0.2,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true,
                        };

                        const compressedFile = await imageCompression(file, options);
                        setStateFunction(compressedFile);
                    }
                } else {
                    console.error(
                        "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
                    );
                }
            } catch (error) {
                console.error("Error processing file:", error);
            }
        }
    };

    const billingFunction = () => {
        setIsSameAddressChecked((prevValue) => !prevValue);
        if (isSameAddressChecked) {
            setAddress11("");
            setAddress22("");
            setAddress33("");
            setPost1("");
            setPolice1("");
            setDistrict1("");
            setTehsil1("");
            setLandmark1("");
            setPincode1("");
            setState1("");
        } else {
            setAddress11(address1);
            setAddress22(address2);
            setAddress33(address3);
            setPost1(post);
            setPolice1(police);
            setDistrict1(district);
            setTehsil1(tehsil);
            setLandmark1(landmark);
            setPincode1(pincode);
            setState1(state);
        }
    };

    const [errors, setErrors] = useState({});

    // Step headings
    const steps = ["Personal Details", "Documents"];

    // Move to previous step
    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    /*first page next......... */
    const validateStep1 = () => {
        const newErrors = {};

        // Required fields validation
        if (!name) newErrors.name = "Name of the Applicant is required";
        if (!fname) newErrors.fname = "Father's Name is required";
        if (!mname) newErrors.mname = "Mother's Name is required";
        if (!gender) newErrors.gender = "Gender is required";
        if (!date) newErrors.date = "Date of Birth is required";
        if (!email) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Invalid email format";
        }
        if (!number) {
            newErrors.number = "Contact Number is required";
        } else if (number.length !== 10) {
            newErrors.number = "Contact Number must be exactly 10 digits";
        }
        
        if (!enumber) {
            newErrors.enumber = "Emergency Contact is required";
        } else if (enumber.length !== 10) {
            newErrors.enumber = "Emergency Contact must be exactly 10 digits";
        }
        
        if (!location) newErrors.location = "Company Location is required";

        // Permanent Address validation
        if (!address1) newErrors.address1 = "Address Line 1 is required";
        if (!post) newErrors.post = "Post Office is required";
        if (!police) newErrors.police = "Police Station is required";
        if (!district) newErrors.district = "District is required";
        if (!pincode) {
            newErrors.pincode = "Pin Code is required";
        } else if (isNaN(pincode)) {
            newErrors.pincode = "Pin Code must be a number";
        }
        if (!tehsil) newErrors.tehsil = "Tehsil is required";
        if (!landmark) newErrors.landmark = "Landmark is required";
        if (!state) newErrors.state = "State is required";

        // Current Address validation
        if (!address11) newErrors.address11 = "Address Line 1 is required";
        if (!post1) newErrors.post1 = "Post Office is required";
        if (!police1) newErrors.police1 = "Police Station is required";
        if (!district1) newErrors.district1 = "District is required";
        if (!pincode1) {
            newErrors.pincode1 = "Pin Code is required";
        } else if (isNaN(pincode1)) {
            newErrors.pincode1 = "Pin Code must be a number";
        }
        if (!tehsil1) newErrors.tehsil1 = "Tehsil is required";
        if (!landmark1) newErrors.landmark1 = "Landmark is required";
        if (!state1) newErrors.state1 = "State is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const nextStep1 = () => {
        if (validateStep1()) {
            setStep((prevStep) => prevStep + 1);
        }
        else {
            alert("Please fill out all required fields");
        }
    };

     const validateStep4 = () => {
        const newErrors = {};

        // Required fields validation
        if (!aadhar) {
            newErrors.aadhar = "Aadhar Number is required";
        } else if (!/^\d{12}$/.test(aadhar)) {
            newErrors.aadhar = "Aadhar must be exactly 12 digits";
        }
        if (!aadhar_front_side) newErrors.aadhar_front_side = "Aadhar Front Side is required";
        if (!aadhar_back_side) newErrors.aadhar_back_side = "Aadhar Back Side is required";
        if (!passport_size_photo) newErrors.passport_size_photo = "passport Size Photo is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /*Fourth page next......... */
    const nextStep4 = (e) => {
        e.preventDefault(); 
        if (validateStep4()) {
            BgcFormSubmit(e);
        } else {
            alert("Please fill out all required fields");
        }
    };
    

    const BgcFormSubmit = async (e) => {
        setIsLoading(true);
        if (e?.preventDefault) e.preventDefault();

        const formData = new FormData();

        formData.append("full_name", name);
        formData.append("fathers_name", fname);
        formData.append("mothers_name", mname);
        formData.append("gender", gender);
        formData.append("dob", date);
        formData.append("email", email);
        formData.append("contact_number", number);
        formData.append("emergency_number", enumber);
        formData.append("name_of_the_client", companyname);
        formData.append("client_location", location);
        formData.append("language_known", language);
        formData.append("blood_group", blood);

        // Permanent Address
        formData.append("permanent_village_city", address1);
        formData.append("permanent_village_city2", address2);
        formData.append("permanent_village_city3", address3);
        formData.append("permanent_post_office", post);
        formData.append("permanent_police_station", police);
        formData.append("permanent_district", district);
        formData.append("permanent_tehsil", tehsil);
        formData.append("permanent_landmark", landmark);
        formData.append("permanent_pincode", pincode);
        formData.append("permanent_state", state);

        // Current Address
        formData.append("current_village_city", address11);
        formData.append("current_village_city2", address22);
        formData.append("current_village_city3", address33);
        formData.append("current_post_office", post1);
        formData.append("current_police_station", police1);
        formData.append("current_district", district1);
        formData.append("current_tehsil", tehsil1);
        formData.append("current_landmark", landmark1);
        formData.append("current_pincode", pincode1);
        formData.append("current_state", state1);

        formData.append("adhar_number", aadhar);
        formData.append("adhar_frontside", aadhar_front_side);
        formData.append("adhar_backside", aadhar_back_side);
        formData.append("photo", passport_size_photo);

        try {
            const response = await fetch("https://humhai.in/background-verification/newform/", {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            console.log(data)
            setCandidateId(data.id);

            if (data.status === 200) {
                alert("Your form has been successfully submitted.");
                setIsLoading(false);
                window.location.reload();
            } else {
                alert("Something went wrong. Please try again.");
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("There was an error submitting the form.");
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            document.querySelectorAll('input, select, textarea, button').forEach(element => {
                element.disabled = false;
            });
        }
    };


    return (
        <div className="form-container">
            {/* Header Section */}
            <div className="form-header">
                {steps.map((heading, index) => (
                    <div
                        key={index}
                        className={`step-title ${step === index + 1 ? "active" : "blurred"}`}
                    >
                        {heading}

                    </div>
                ))}
            </div>

            {/* Form Content */}
            <div className="form-content">
                {step === 1 && <div>

                    <div className="bg-light p-3 rounded-lg border border-opacity-50 mx-auto p-1">
                        <h2 className="text-center font-bold text-3xl mb-3">
                            CANDIDATE{" "}
                            <span className="text-orange-600">PERSONAL DETAILS</span>
                        </h2>
                        <hr />
                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="name_of_applicant" className="form-label">
                                    Name of the Applicant
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.name ? 'is-invalid' : ''}`}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    name="name_of_applicant"
                                    required
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input2" className="form-label">
                                    Fathers/Husband/Wife Name
                                </label>
                                <input
                                    className={`inputtype form-control mb-3 ${errors.fname ? 'is-invalid' : ''}`}
                                    list="projects"
                                    value={fname}
                                    onChange={(e) => setFname(e.target.value)}
                                    name="fathers_name"
                                    maxLength="100"
                                    required
                                />
                                {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input3" className="form-label">
                                    Mother's Name
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.mname ? 'is-invalid' : ''}`}
                                    value={mname}
                                    onChange={(e) => setMname(e.target.value)}
                                    name="mothers_name"
                                    maxLength="100"
                                    required
                                />
                                {errors.mname && <div className="invalid-feedback">{errors.mname}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input4" className="form-label">
                                    Applicant Gender
                                </label>{" "}
                                <select
                                    className={`inputtype form-control mb-3 ${errors.gender ? 'is-invalid' : ''}`}
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                    name="gender"
                                >
                                    <option value="">choose</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="other">other</option>
                                </select>
                                {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
                            </div>

                            <div className="col-md-4 input-icons">
                                <label htmlFor="Input5" className="form-label">
                                    Date Of Birth
                                </label>

                                <div className="date-container">
                                    <input
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        type="date"
                                        className={`inputtype form-control mb-3 ${errors.date ? 'is-invalid' : ''}`}
                                        name="dob"
                                        required
                                    />
                                    {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                                </div>
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input6" className="form-label">
                                    Email Id
                                </label>{" "}

                                <input
                                    type="email"
                                    className={`inputtype form-control mb-3 ${errors.email ? 'is-invalid' : ''}`}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    name="email"
                                    required
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 input-icons">
                                <label htmlFor="Input5" className="form-label">
                                    Contact Number
                                </label>

                                <div className="date-container">
                                    <input
                                        type="number"
                                        className={`inputtype form-control mb-3 ${errors.number ? 'is-invalid' : ''}`}
                                        value={number}
                                        // onChange={(e) => setNumber(e.target.value)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,10}$/.test(value)) { 
                                                setNumber(value);
                                            }
                                        }}
                                        name="contact_number"
                                        required
                                    />
                                    {errors.number && <div className="invalid-feedback">{errors.number}</div>}
                                </div>
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input6" className="form-label">
                                    Emergency Contact
                                </label>

                                <input
                                    type="number"
                                    className={`inputtype form-control mb-3 ${errors.enumber ? 'is-invalid' : ''}`}
                                    value={enumber}
                                    // onChange={(e) => setEnumber(e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d{0,10}$/.test(value)) {
                                            setEnumber(value);
                                        }
                                    }}
                                    name="emergency_contact"
                                    required
                                />
                                {errors.enumber && <div className="invalid-feedback">{errors.enumber}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Company Name
                                </label>

                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={companyname}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    name="name_of_client"
                                    maxLength="100"
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Company Location
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.location ? 'is-invalid' : ''}`}
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    name="client_location"
                                    maxLength="30"
                                    required
                                />
                                {errors.location && <div className="invalid-feedback">{errors.location}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Languages Known (optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={language}
                                    onChange={(e) => setLanguage(e.target.value)}
                                    name="languages"
                                    maxLength="30"
                                />
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Blood Group (optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={blood}
                                    onChange={(e) => setBlood(e.target.value)}
                                    name="blood_group"
                                    maxLength="5"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <h2>Permanent Address</h2>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 1
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.address1 ? 'is-invalid' : ''}`}
                                    value={address1}
                                    onChange={(e) => setAddress1(e.target.value)}
                                    name="village_city"
                                    maxLength="25"
                                    required
                                />
                                {errors.address1 && <div className="invalid-feedback">{errors.address1}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 2 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                    name="village_city2"
                                    maxLength="25"
                                />
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 3 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address3}
                                    onChange={(e) => setAddress3(e.target.value)}
                                    name="village_city3"
                                    maxLength="25"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Name of Post Office
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.post ? 'is-invalid' : ''}`}
                                    value={post}
                                    onChange={(e) => setPost(e.target.value)}
                                    name="post_office"
                                    maxLength="100"
                                    required
                                />
                                {errors.post && <div className="invalid-feedback">{errors.post}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Police Station/Thana
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.police ? 'is-invalid' : ''}`}
                                    value={police}
                                    onChange={(e) => setPolice(e.target.value)}
                                    name="police_station"
                                    maxLength="100"
                                    required
                                />
                                {errors.police && <div className="invalid-feedback">{errors.police}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    District
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.district ? 'is-invalid' : ''}`}
                                    value={district}
                                    onChange={(e) => setDistrict(e.target.value)}
                                    name="district"
                                    maxLength="100"
                                    required
                                />
                                {errors.district && <div className="invalid-feedback">{errors.district}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Tehsil
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.tehsil ? 'is-invalid' : ''}`}
                                    value={tehsil}
                                    onChange={(e) => setTehsil(e.target.value)}
                                    name="tehsil"
                                    maxLength="100"
                                    required
                                />
                                {errors.tehsil && <div className="invalid-feedback">{errors.tehsil}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Landmark
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.landmark ? 'is-invalid' : ''}`}
                                    value={landmark}
                                    onChange={(e) => setLandmark(e.target.value)}
                                    name="landmark"
                                    maxLength="100"
                                    required
                                />
                                {errors.landmark && <div className="invalid-feedback">{errors.landmark}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Pin Code
                                </label>
                                <input
                                    type="number"
                                    className={`inputtype form-control mb-3 ${errors.pincode ? 'is-invalid' : ''}`}
                                    value={pincode}
                                    onChange={(e) => setPincode(e.target.value)}
                                    name="pine_code"
                                    required
                                />
                                {errors.pincode && <div className="invalid-feedback">{errors.pincode}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    State
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.state ? 'is-invalid' : ''}`}
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}
                                    name="state"
                                    maxLength="20"
                                    required
                                />
                                {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                            </div>
                        </div>

                        <div className="row mb-4 d-flex flex-row">
                            <label
                                style={{ width: "190px" }}
                                className="form-label"
                                htmlFor="same"
                            >
                                Same as above?
                            </label>
                            <input
                                style={{ width: "30px" }}
                                type="checkbox"
                                id="same"
                                name="same"
                                onChange={() => billingFunction()}
                            />
                        </div>

                        <div className="row">
                            <h2>Current Address</h2>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 1
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.address11 ? 'is-invalid' : ''}`}
                                    value={address11}
                                    onChange={(e) => setAddress11(e.target.value)}
                                    name="c_village_city"
                                    maxLength="25"
                                    required
                                />
                                {errors.address11 && <div className="invalid-feedback">{errors.address11}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 2 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address22}
                                    onChange={(e) => setAddress22(e.target.value)}
                                    name="c_village_city2"
                                    maxLength="25"
                                />
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 3 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address33}
                                    onChange={(e) => setAddress33(e.target.value)}
                                    name="c_village_city3"
                                    maxLength="25"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Name of Post Office
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.post1 ? 'is-invalid' : ''}`}
                                    value={post1}
                                    onChange={(e) => setPost1(e.target.value)}
                                    name="c_post_office"
                                    maxLength="100"
                                    required
                                />
                                {errors.post1 && <div className="invalid-feedback">{errors.post1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Police Station
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.police1 ? 'is-invalid' : ''}`}
                                    value={police1}
                                    onChange={(e) => setPolice1(e.target.value)}
                                    name="c_police_station"
                                    maxLength="100"
                                    required
                                />
                                {errors.police1 && <div className="invalid-feedback">{errors.police1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    District
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.district1 ? 'is-invalid' : ''}`}
                                    value={district1}
                                    onChange={(e) => setDistrict1(e.target.value)}
                                    name="c_district"
                                    maxLength="100"
                                    required
                                />
                                {errors.district1 && <div className="invalid-feedback">{errors.district1}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Tehsil
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.tehsil1 ? 'is-invalid' : ''}`}
                                    value={tehsil1}
                                    onChange={(e) => setTehsil1(e.target.value)}
                                    name="c_tehsil"
                                    maxLength="100"
                                    required
                                />
                                {errors.tehsil1 && <div className="invalid-feedback">{errors.tehsil1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Landmark
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.landmark1 ? 'is-invalid' : ''}`}
                                    value={landmark1}
                                    onChange={(e) => setLandmark1(e.target.value)}
                                    name="c_landmark"
                                    maxLength="100"
                                    required
                                />
                                {errors.landmark1 && <div className="invalid-feedback">{errors.landmark1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Pin Code
                                </label>
                                <input
                                    type="number"
                                    className={`inputtype form-control mb-3 ${errors.pincode1 ? 'is-invalid' : ''}`}
                                    value={pincode1}
                                    onChange={(e) => setPincode1(e.target.value)}
                                    name="c_pine_code"
                                    maxLength="100"
                                    required
                                />
                                {errors.pincode1 && <div className="invalid-feedback">{errors.pincode1}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    State
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.state1 ? 'is-invalid' : ''}`}
                                    value={state1}
                                    onChange={(e) => setState1(e.target.value)}
                                    name="c_state"
                                    maxLength="20"
                                    required
                                />
                                {errors.state1 && <div className="invalid-feedback">{errors.state1}</div>}
                            </div>
                        </div>
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep1}
                            >
                                Next
                            </button>
                        </div>
                    </div>

                </div>}


                {step === 2 && <div>
                    <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
                        <div className="text-center font-bold text-3xl" >📄 CANDIDATE
                            <span style={{ color: "rgb(255, 119, 0)" }}>{" "}DOCUMENTS{" "}</span>{" "}DETAILS
                        </div>
                        <h5 className=" text-center" style={{ color: "rgb(255, 119, 0)" }}>
                            * Upload a Fully Clear and Completed Document *
                        </h5>
                        <h4 style={{ color: "red", textAlign: "center" }}>* use .jpg and .png format * </h4>
                        <hr />
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="Input7" className="form-label">Aadhar Card Number</label>
                                <input
                                    type="text" 
                                    value={aadhar}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                        setAadhar(value);
                                        if (errors.aadhar && value.length === 12) {
                                            setErrors({ ...errors, aadhar: '' });
                                        }
                                    }}
                                    name="aadhar_card"
                                    className={`inputtype form-control mb-3 ${errors.aadhar ? 'is-invalid' : ''}`}
                                    inputMode="numeric"  
                                    pattern="\d{12}"    
                                    maxLength="12"   
                                    placeholder="Enter 12-digit Aadhar number"
                                    required
                                />
                                {errors.aadhar && (
                                    <div className="invalid-feedback">
                                        {errors.aadhar === "Aadhar Number is required"
                                            ? "Aadhar Number is required"
                                            : "Aadhar must be exactly 12 digits (numbers only)"}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Input8" className="form-label">Aadhar Card FRONT SIDE</label>
                                <input
                                    type="file"
                                    onChange={(e) =>
                                        handleFileChange(e, setAadhar_Front_Side)
                                    }
                                    accept=".png, .jpg"
                                    name="aadhar_front"
                                    className={`inputtype form-control mb-3 ${errors.aadhar_front_side ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.aadhar_front_side && <div className="invalid-feedback">{errors.aadhar_front_side}</div>}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Input9" className="form-label">Aadhar Card BACK SIDE</label>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, setAadhar_Back_Side)}
                                    name="aadhar_back"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.aadhar_back_side ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.aadhar_back_side && <div className="invalid-feedback">{errors.aadhar_back_side}</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="Input9" className="form-label">Passport Size Photo</label>
                                <input
                                    type="file"
                                    onChange={(e) =>
                                        handleFileChange(e, setPassport_Size_Photo)
                                    }
                                    name="passport_photo"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.passport_size_photo ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.passport_size_photo && <div className="invalid-feedback">{errors.passport_size_photo}</div>}
                            </div>

                        </div>
                        <div className="row ms-4 mb-4">
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: "1",
                                        flexDirection: "column",
                                    }}
                                >
                                    {" "}
                                    <img src={img} alt="" />
                                    <div style={{ color: "#DE3500", marginTop: "10px" }}>
                                        Please Wait ......
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                style={{ backgroundColor: "#BBBBBB" }}
                                onClick={prevStep}
                                disabled={isLoading}
                            >
                                Previous
                            </button>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep4}
                                disabled={isLoading}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>}

            </div>
        </div>
    );
};
export default BgcForm;
